import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice'
import temporalUserReducer from '../features/auth/temporalUserSlice'
import documentsReducer from '../features/documents/documentsSlice'
import paymentsReducer from '../features/payments/paymentsSlice'
import usersReducer from '../features/users/usersSlice'
import optionsReducer from '../features/options/optionsSlice'
import uiReducer from '../features/ui/uiSlice'
import emailsReducer from '../features/emails/emailsSlice'
import newsReducer from '@/features/news/newsSlice'
import formsReducer from '@/features/documents/formsSlice'
import searchReducer from '@/features/search/searchSlice'
import sitesReducer from '@/features/sites/sitesSlice'
import mediaReducer from '@/features/media/mediaSlice'
import carouselReducer from '@/features/carousel/carouselSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    temporalUser: temporalUserReducer,
    documents: documentsReducer,
    payments: paymentsReducer,
    users: usersReducer,
    options: optionsReducer,
    ui: uiReducer,
    emails: emailsReducer,
    news: newsReducer,
    forms: formsReducer,
    search: searchReducer,
    sites: sitesReducer,
    media: mediaReducer,
    carousel: carouselReducer,
  },
  // El objeto `User` de Firebase guardado en `auth.authUser` contiene propiedades
  // no-serializables (proactiveRefresh, stsTokenManager). RTK loguea un warning por
  // cada dispatch que escanea el state. Ignoramos esa rama para silenciar ruido
  // sin alterar comportamiento — patrón estándar Firebase + Redux Toolkit.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['auth.authUser'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
